import examAPI from "../examAPI";

// ========== AVAILABLE EXAMS ==========

export const getAvailableExams = ({
  params: { page, page_size, search, category } = {},
  signal,
} = {}) => {
  return examAPI
    .get("/exams/exams/", {
      params: { page, page_size, search, category },
      signal,
    })
    .then((res) => res?.data);
};

export const getExamDetail = ({ uuid, signal } = {}) => {
  return examAPI.get(`/exams/exams/${uuid}/`, { signal }).then((res) => res?.data);
};

// ========== ATTEMPTS ==========

export const getMyAttempts = ({
  params: { page, page_size, status, exam } = {},
  signal,
} = {}) => {
  return examAPI
    .get("/exams/attempts/", {
      params: { page, page_size, status, exam },
      signal,
    })
    .then((res) => res?.data);
};

export const getAttempt = ({ uuid, signal } = {}) => {
  return examAPI.get(`/exams/attempts/${uuid}/`, { signal }).then((res) => res?.data);
};

export const startAttempt = ({ data, signal } = {}) => {
  return examAPI.post("/exams/attempts/start/", data, { signal }).then((res) => res?.data);
};

export const submitAnswer = ({ uuid, data, signal } = {}) => {
  return examAPI
    .post(`/exams/attempts/${uuid}/answer/`, data, { signal })
    .then((res) => res?.data);
};

export const submitAttempt = ({ uuid, data = {}, signal } = {}) => {
  return examAPI.post(`/exams/attempts/${uuid}/submit/`, data, { signal }).then((res) => res?.data);
};

export const getAttemptResult = ({ uuid, signal } = {}) => {
  return examAPI.get(`/exams/attempts/${uuid}/result/`, { signal }).then((res) => res?.data);
};

export const getAttemptReview = ({ uuid, signal } = {}) => {
  return examAPI.get(`/exams/attempts/${uuid}/review/`, { signal }).then((res) => res?.data);
};
